module.exports = __webpack_public_path__ + "static/media/Report-.69856dac.png";